/** packages/shared-components/src/components/Message/Message.tsx */

import React, { useEffect, useRef, useState } from "react";
import { Iconfont } from "../Iconfont";
import "./Message.css";

export type MessageType = "success" | "error" | "warning" | "info";

const MESSAGE_ICON_MAP: Record<MessageType, string> = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "information",
};

export interface MessageProps {
  message: string;
  type?: MessageType;
  duration?: number;
  onClose?: () => void;
}

export const Message: React.FC<MessageProps> = ({
  message,
  type = "info",
  duration = 3000,
  onClose,
}) => {
  const [animationState, setAnimationState] = useState<
    "mounting" | "mounted" | "unmounting"
  >("mounting");

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const timer = requestAnimationFrame(() => {
      requestAnimationFrame(() => setAnimationState("mounted"));
    });
    return () => cancelAnimationFrame(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState("unmounting");
      setTimeout(() => onCloseRef.current?.(), 400);
    }, duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <div className={`message message-${type} message-${animationState}`}>
      <div className="message-content">
        <div className="message-icon">
          <Iconfont
            icon={MESSAGE_ICON_MAP[type]}
            className="message-iconfont"
          />
        </div>
        <span className="message-text">{message}</span>
      </div>
    </div>
  );
};
